// Card de información estática sobre el sistema de ofertas

import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Card informativa con bullet points sobre el funcionamiento del sistema
 * Contenido estático, generalmente se coloca al final del layout
 */
export const InfoCard = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-slate-800/30 backdrop-blur-xl rounded-xl p-3 border border-slate-700/30">
      <h3 className="text-sm font-semibold text-white mb-2">{t('info.title')}</h3>
      <ul className="space-y-1.5 text-slate-400 text-xs">
        <li>• {t('info.bullet1')}</li>
        <li>• {t('info.bullet2')}</li>
        <li>• {t('info.bullet3')}</li>
        <li>• {t('info.bullet4')}</li>
      </ul>
    </div>
  );
};

export default InfoCard;
